import msalInstance from "../config/msLogin";

const logout = () => {
  return msalInstance
    .logoutRedirect()
    .then(() => localStorage.removeItem("msToken"));
};

export default logout;
